const KEYS_MAP = {
  helping: 'helping',
  needHelp: 'need-help',
  contentIssue: 'content-issue',
  enhancedRequest: 'enhanced-request',
  other: 'other',
};

const sortKeys = (a, b) => {
  if (a.id === 'other') {
    return 1;
  }

  return a.label.localeCompare(b.label);
};

const userTypes = [
  {
    id: KEYS_MAP.needHelp,
    label: 'Mine',
    value: 'Mine',
  },
  {
    id: KEYS_MAP.helping,
    label: 'My Students',
    value: 'My Students',
  },
].sort(sortKeys);

const other = {
  id: 'other',
  label: 'Other',
  value: 'Other',
};

const apDailyVideo = {
  id: 'AP Daily Videos',
  label: 'AP Daily Videos',
  value: 'AP Daily Videos',
};

const practiceExam = {
  id: 'Practice Exams',
  label: 'Practice Exams',
  value: 'Practice Exams',
};

const progressChecks = {
  id: 'Progress Checks',
  label: 'Progress Checks',
  value: 'Progress Checks',
};

const contentSkillsPerformance = {
  id: 'Content & Skills Performance',
  label: 'Content & Skills Performance',
  value: 'Content & Skills Performance',
};

const blankScreen = {
  id: 'Blank Screen/Error Message',
  label: 'Blank Screen/Error Message',
  value: 'Blank Screen/Error Message',
};

const examOnlyStudent = {
  id: 'exam-only-student',
  label: 'Exam Only Student',
  value: 'Exam Only Student',
};

const findingResource = {
  id: 'finding-resource',
  label: 'Finding Resource',
  value: 'Finding Resource',
};

const studentPracticeProblem = {
  id: 'student-practice-problems',
  label: 'Student Practice Problems',
  value: 'Student Practice Problems',
};

const joinCode = {
  id: 'join-code',
  label: 'Join Code',
  value: 'Join Code',
};
const enrollment = {
  id: 'enrollment',
  label: 'Enrollment',
  value: 'Enrollment',
};
const loginPassword = {
  id: 'login-password',
  label: 'Login/Password',
  value: 'Login/Password',
};
const lockDownBrowser = {
  id: 'lockDown-browser',
  label: 'LockDown Browser',
  value: 'LockDown Browser',
};
const myClasses = {
  id: 'my-classes',
  label: 'My classes',
  value: 'My classes',
};

const quizzes = {
  id: 'Quizzes',
  label: 'Quizzes',
  value: 'Quizzes',
};

const topicQuestions = {
  id: 'Topic Questions',
  label: 'Topic Questions',
  value: 'Topic Questions',
};

const howToPrint = {
  id: 'How To Print',
  label: 'How To Print',
  value: 'How To Print',
};

const issueTypes = [
  {
    id: 'access',
    label: 'Access',
    value: 'Access',
    questionIssue: [
      blankScreen,
      {
        id: 'how-to',
        label: 'How To',
        value: 'How To',
      },
      {
        id: 'site-loading-issue-outage',
        label: 'Site Loading Issue/Outage',
        value: 'Site Loading Issue/Outage',
      },
      other,
    ].sort(sortKeys),
    areaOfIssue: {
      educator: [
        joinCode,
        enrollment,
        loginPassword,
        lockDownBrowser,
        myClasses,
        {
          id: 'professional-learning',
          label: 'Professional Learning',
          value: 'Professional Learning',
        },
        other,
      ].sort(sortKeys),
      student: [
        joinCode,
        enrollment,
        loginPassword,
        lockDownBrowser,
        myClasses,
        other,
      ].sort(sortKeys),
    },
  },
  {
    id: 'assignments',
    label: 'Assignments',
    value: 'Assignments',
    questionIssue: {
      educator: [
        {
          id: 'Assign/Unassign',
          label: 'Assign/Unassign',
          value: 'Assign/Unassign',
        },
        {
          id: 'Assignment Progress',
          label: 'Assignment Progress',
          value: 'Assignment Progress',
        },
        {
          id: 'Authoring New Questions',
          label: 'Authoring New Questions',
          value: 'Authoring New Questions',
        },
        blankScreen,
        {
          id: 'Building a Quiz',
          label: 'Building a Quiz',
          value: 'Building a Quiz',
        },
        examOnlyStudent,
        findingResource,
        {
          id: 'Previous Assignments',
          label: 'Previous Assignments',
          value: 'Previous Assignments',
        },
        {
          id: 'processing-answer-sheets',
          label: 'Processing Answer Sheets',
          value: 'Processing Answer Sheets',
        },
        {
          id: 'Scoring Student Work',
          label: 'Scoring Student Work',
          value: 'Scoring Student Work',
        },
        {
          id: 'scramble-questions',
          label: 'Scramble Questions',
          value: 'Scramble Questions',
        },
        {
          id: 'Shared Quizzes',
          label: 'Shared Quizzes',
          value: 'Shared Quizzes',
        },
        {
          id: 'Submit/Un-submit',
          label: 'Submit/Un-submit',
          value: 'Submit/Un-submit',
        },
        {
          id: 'Update/Delete',
          label: 'Update/Delete',
          value: 'Update/Delete',
        },
        other,
      ].sort(sortKeys),
      student: [blankScreen, examOnlyStudent, findingResource, other].sort(
        sortKeys,
      ),
    },
    areaOfIssue: {
      educator: [
        {
          id: 'answer-sheets',
          label: 'Answer Sheets',
          value: 'Answer Sheets',
        },
        apDailyVideo,
        {
          id: 'Labels',
          label: 'Labels',
          value: 'Labels',
        },
        practiceExam,
        progressChecks,
        topicQuestions,
        quizzes,
        studentPracticeProblem,
        other,
      ].sort(sortKeys),
      student: [
        apDailyVideo,
        practiceExam,
        progressChecks,
        quizzes,
        studentPracticeProblem,
        other,
      ].sort(sortKeys),
    },
  },
  {
    id: 'printing',
    label: 'Printing',
    value: 'Printing',
    questionIssue: {
      educator: [
        howToPrint,
        {
          id: 'Formatting',
          label: 'Formatting',
          value: 'Formatting',
        },
        blankScreen,
        other,
      ].sort(sortKeys),
      student: [howToPrint, blankScreen, other].sort(sortKeys),
    },
    areaOfIssue: {
      educator: [
        {
          id: 'Handouts',
          label: 'Handouts',
          value: 'Handouts',
        },
        practiceExam,
        progressChecks,
        quizzes,
        {
          id: 'Scoring Worksheet',
          label: 'Scoring Worksheet',
          value: 'Scoring Worksheet',
        },
        {
          id: 'Answer Keys/Scoring Guidelines',
          label: 'Answer Keys/Scoring Guidelines',
          value: 'Answer Keys/Scoring Guidelines',
        },
        {
          id: 'Test Books',
          label: 'Test Books',
          value: 'Test Books',
        },
        other,
      ].sort(sortKeys),
      student: [practiceExam, progressChecks, quizzes, other].sort(sortKeys),
    },
  },
  {
    id: 'reports',
    label: 'Reports',
    value: 'Reports',
    questionIssue: {
      educator: [
        {
          id: 'Results Overview',
          label: 'Results Overview',
          value: 'Results Overview',
        },
        blankScreen,
        other,
      ].sort(sortKeys),
      student: [other],
    },
    areaOfIssue: {
      educator: [
        apDailyVideo,
        contentSkillsPerformance,
        {
          id: 'Exporting Results',
          label: 'Exporting Results',
          value: 'Exporting Results',
        },
        practiceExam,
        progressChecks,
        quizzes,
        {
          id: 'usage-reports-admins',
          label: 'Usage Reports-Admins',
          value: 'Usage Reports-Admins',
        },
        other,
      ].sort(sortKeys),
      student: [contentSkillsPerformance, progressChecks, other].sort(sortKeys),
    },
  },
  {
    id: KEYS_MAP.contentIssue,
    label: 'Content Issue',
    value: 'Content Issue',
    questionIssue: [
      {
        id: 'Calculation Error',
        label: 'Calculation Error',
        value: 'Calculation Error',
      },
      {
        id: 'Typographical error',
        label: 'Typographical error',
        value: 'Typographical error',
      },
      {
        id: 'Image, graph, artwork issue',
        label: 'Image, graph, artwork issue',
        value: 'Image, graph, artwork issue',
      },
      {
        id: 'Audio/Text stimulus issue',
        label: 'Audio/Text stimulus issue',
        value: 'Audio/Text stimulus issue',
      },
      {
        id: 'Alignment feedback',
        label: 'Alignment feedback',
        value: 'Alignment feedback',
      },
      {
        id: 'Other/General feedback',
        label: 'Other/General feedback',
        value: 'Other/General feedback',
      },
      {
        id: 'Incorrect Content',
        label: 'Incorrect Content',
        value: 'Incorrect Content',
      },
      {
        id: 'Sensitive Content',
        label: 'Sensitive Content',
        value: 'Sensitive Content',
      },
      {
        id: 'external-resource',
        label: 'External Resource',
        value: 'External Resource',
      },
    ].sort(sortKeys),
    areaOfIssue: [
      apDailyVideo,
      {
        id: 'Course Exam & Description',
        label: 'Course Exam & Description',
        value: 'Course Exam & Description',
      },
      practiceExam,
      progressChecks,
      topicQuestions,
      {
        id: 'Question Bank',
        label: 'Question Bank',
        value: 'Question Bank',
      },
      other,
    ].sort(sortKeys),
  },
  {
    id: KEYS_MAP.enhancedRequest,
    label: 'Enhancement/Feature Request',
    value: 'Enhancement/Feature Request',
  },
  other,
].sort(sortKeys);

export { userTypes, issueTypes, KEYS_MAP };
